export default __webpack_public_path__ + "media/images/portfolio/gallery-08-480x580-422164397cba2bbc54fd525034103254.jpg";